import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { MenuItem } from "@mui/material";
import { NewRequestMetadataInputProps, NewRequestSelect } from "../new-request-metadata-input";
import { useRef } from "react";

const NewRequestInputLangMulti = (props: NewRequestMetadataInputProps) => {
  const { metadata, value, isErrored, onChange } = props;
  const inputRef: any = useRef(null);

  const handleOnChange = (value: any) => {
    onChange(value);
  };
  return (
    <NewRequestSelect
      multiple
      IconComponent={ExpandMoreRoundedIcon}
      value={value?.flatMap((x) => x.value) || []}
      onChange={(event) => handleOnChange(event.target.value)}
      onFocus={(e) => inputRef.current?.focus()}
      error={isErrored}
      MenuProps={{
        PaperProps: { sx: { maxHeight: 400, maxWidth: 250 } },
      }}
    >
      {metadata.values?.map((value, index) => (
        <MenuItem ref={index === 0 ? inputRef : null} key={index} value={value.value!}>
          {value.label!}
        </MenuItem>
      ))}
    </NewRequestSelect>
  );
};

export default NewRequestInputLangMulti;
